import { Link } from "gatsby";
import styled, { css, device, themeGet } from "../styled";

const ButtonStyled = css`
    border: none;
    border-radius: 2px;
    background-color: var(--primary-color);
    color: #fff;
    text-decoration: none;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    width: 300px;
    padding: 12px 0;
    &:hover {
        color: var(--secondary-color);
    }
`;

export const LinkButton = styled(Link)`
    ${ButtonStyled}
`;

export const HashButton = styled.a`
    ${ButtonStyled}
`;
